module.exports = __webpack_public_path__ + "img/11.6c29da51.jpg";